export const FETCHED_FAQS = 'FETCHED_FAQS';
export const FETCHED_FAQ = 'FETCHED_FAQ';
export const FETCH_FAQS_TYPES = 'FETCH_FAQS_TYPES';
export const CREATED_FAQ = 'CREATED_FAQ';
export const UPDATED_FAQ = 'UPDATED_FAQ';
export const DELETED_FAQ = 'DELETED_FAQ';
export const FETCHED_FAQS_TRANSLATIONS = 'FETCHED_FAQS_TRANSLATIONS';
export const FETCHED_FAQ_TRANSLATION = 'FETCHED_FAQ_TRANSLATION';
export const CREATED_FAQ_TRANSLATION = 'CREATED_FAQ_TRANSLATION';
export const UPDATED_FAQ_TRANSLATION = 'UPDATED_FAQ_TRANSLATION';
export const DELETED_FAQ_TRANSLATION = 'DELETED_FAQ_TRANSLATION';
export const FAQ_SEARCH_BY = 'FAQ_SEARCH_BY';
export const FETCHED_FAQS_BY_SEARCH_TERMS = 'FETCHED_FAQS_BY_SEARCH_TERMS';
export const CLEAR_FAQS_SEARCH_FILTER = 'CLEAR_FAQS_SEARCH_FILTER';


// WEBPACK FOOTER //
// ./src/containers/faqs/types.js